import {Component, OnInit, AfterViewInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {StorageService} from '../../../../Services/storage.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';


@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css'],
  standalone: false
})

export class CompanyListComponent extends ListPageBase implements OnInit, AfterViewInit {

  // Localized column headers for the shared DataTableComponent
  public readonly labelShortName: string = $localize`:Short Name@@shortName:Short Name`;
  public readonly labelName: string = $localize`:Name@@name:Name`;
  public readonly labelYearEndDate: string = $localize`:Year End Date@@yearEndDate:Year End Date`;
  public readonly labelCutOffDate: string = $localize`:Cut Off Date@@cutOffDate:Cut Off Date`;
  public readonly labelDBA: string = $localize`:DBA@@dba:DBA`;
  public readonly labelActive: string = $localize`:Active@@active:Active`;

  constructor(private aTable: DataService,
              private notification: BsToastService,
              private aRoute: Router,
              private aStorage: StorageService,
              private dateFilter: DateFilterService,
              private ngbConfig: NgbPaginationConfig,
              private pagerConfig: NgbpaginationConfigService,
              private titleService: Title
  ) {
    super();
              this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  companyCount = 0;
  isLoaded = false;




  vm: any = [];

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.getData();
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Company List @@companyList:Company List`);
  }



  getData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0 ) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('company', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.companyCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.notification.showErrorToast($localize`:Error loading Company Data @@errorLoadingCompanyData:Error loading Company Data`);
        console.log(error);
      },
      () => {}
      );
  }

  saveClose() {

  }

  saveNew() {

  }

  deleteItem() {

  }

  resetForm() {

  }

  onClose() {

  }

   // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

   getPagedApiData()
   {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0 ) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('company', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.companyCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.notification.showErrorToast($localize`:Error loading Company Data @@errorLoadingCompanyData:Error loading Company Data`);
        console.log(error);
      },
      () => {}
      );
   }

   onNavigate(aID: string) {
    this.aRoute.navigate(['admin/company-form', { id: aID }]).then();
  }

   serverSearch(value) {
     // console.log(value);
     this.vm.searchTerm = value.searchTerm;
     this.vm.fromDate = value.fromDate;
     this.vm.toDate = value.toDate;
     this.page = 1;
     this.getPagedApiData();
   }

   clearServerSearch(value) {
     this.vm.searchTerm = value.searchTerm;
     this.vm.fromDate = value.fromDate;
     this.vm.toDate = value.toDate;
     this.page = 1;
     this.getPagedApiData();
   }

   hideSearch() {
     this.vm.searchHidden = !this.vm.searchHidden;
   }
}
